// @flow
import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Modal from "../modal/modal";
import styles from "./ticketingCcModal.scss";
import BasicSelect from "../formElements/basicSelect/basicSelect";
import { getEmailCcOptions } from "./ticketingCcModalRedux/ticketingCcModalActionCreator";

const closeIcnUrl = require("../../../assets/images/close_icn.svg");

type Props = {
  showLoader: boolean,
  showModal: boolean,
  title: string,
  closeModal: Function,
  ccList: Array<any>,
  addToCCList: Function,
  deleteFromCCList: Function,
  getEmailCcOptions: Function,
  ticketingCcModalState: Object
};

class TicketingCcModal extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      showTicketingCcOptions: false,
      selectedEmailId: ""
    };
  }

  onSelectEmail(val, event) {
    this.setState(
      {
        showTicketingCcOptions: false
      },
      () => {
        this.props.addToCCList(event.email);
      }
    );
  }

  onChangeEmailInput(val) {
    this.setState(
      {
        showTicketingCcOptions: true
      },
      () => {
        this.props.getEmailCcOptions(val);
      }
    );
  }

  getOptions() {
    const { emailCcOptionsDetails } = this.props.ticketingCcModalState;
    const options = [];
    if (emailCcOptionsDetails.data && emailCcOptionsDetails.data.length) {
      emailCcOptionsDetails.data.forEach(option =>
        options.push({
          key: option.name ? `${option.name} ${option.email}` : option.email,
          val: option.name ? `${option.name} ${option.email}` : option.email,
          id: option.id,
          email: option.email
        })
      );
    }
    return options;
  }

  renderCCList() {
    if (!this.props.ccList) {
      return null;
    }
    return this.props.ccList.map((object, i) => (
      <div className="l-row a-center" key={i}>
        <div className={styles.emailText}>
          {i + 1}. {object.userEmail}
        </div>
        <div onClick={() => this.props.deleteFromCCList(i)}>
          <img className={styles.deleteIcon} src={closeIcnUrl} alt="remove" />
        </div>
      </div>
    ));
  }

  renderInputBoxForNewCC() {
    return (
      <div>
        <BasicSelect
          label="Enter email/name id for cc"
          optionsArrOfObj={this.getOptions()}
          onSelect={(val, event) => {
            this.onSelectEmail(val, event);
          }}
          enableSearch={true}
          showOptions={this.state.showTicketingCcOptions}
          onChangeInput={val => {
            this.onChangeEmailInput(val);
          }}
          selectedOpt={this.state.selectedEmailId}
          hideSelectedOption={true}
        />
      </div>
    );
  }

  render() {
    return (
      <Modal
        showLoader={this.props.showLoader}
        showModal={this.props.showModal}
        title={this.props.title}
        closeModal={this.props.closeModal}
      >
        <div className={styles.ticketingCcModalWrapper}>
          <div>{this.renderInputBoxForNewCC()}</div>
          <div>{this.renderCCList()}</div>
        </div>
        <div className={`l-row flex-100 ${styles.confirmBtnWrapper}`}>
          <div
            className={` ${styles.confirmBtn} l-row a-center j-center`}
            onClick={() => this.props.closeModal()}
          >
            Done
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  ticketingCcModalState: state.ticketingCcModalState
});

const mapDispatchToProps = dispatch => ({
  getEmailCcOptions: bindActionCreators(getEmailCcOptions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketingCcModal);



// WEBPACK FOOTER //
// ./app/components/commons/ticketingCcModal/ticketingCcModal.js